import { pxToRem } from '@packages/themes/utils';
import { GRID_CONTENT_MAX_WIDTH_PX, gridMargins } from '@packages/themes/v4';
import { makeStyles } from '@/styles/v4/tss-react';

const useStyles = makeStyles({ name: 'MultiProductPage' })(
  ({ palette, breakpoints, spacing }) => ({
    root: {
      minHeight: '100vh',
      paddingTop: spacing(5),
      paddingBottom: spacing(5),
      paddingLeft: pxToRem(gridMargins.xs),
      paddingRight: pxToRem(gridMargins.xs),
      backgroundColor: palette.semantic.bg.primary,
      backgroundImage: palette.gradients.backgroundGradient,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      [breakpoints.up('md')]: {
        paddingLeft: pxToRem(gridMargins.md),
        paddingRight: pxToRem(gridMargins.md),
      },
      [breakpoints.up('lg')]: {
        paddingLeft: pxToRem(gridMargins.lg),
        paddingRight: pxToRem(gridMargins.lg),
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      width: '100%',
      [breakpoints.up('md')]: {
        gap: spacing(4),
      },
      maxWidth: pxToRem(GRID_CONTENT_MAX_WIDTH_PX),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    products: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      [breakpoints.up('md')]: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(0, 1fr)',
        columnGap: spacing(1),
        rowGap: 0,
      },
    },
  })
);

export default useStyles;
